
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20","data-token-name":"document-hr"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#a)","stroke":"currentColor","stroke-width":"1.25","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M11.877 17.608H2.05a.833.833 0 01-.833-.834V1.452A.833.833 0 012.049.62h11.132a.833.833 0 01.833.833v2.25"}}),_c('path',{attrs:{"d":"M9.212 9.84a1.666 1.666 0 100-3.332 1.666 1.666 0 000 3.332zm3.561 3.525c-1.036-3.454-6.194-3.277-7.228.167"}}),_c('path',{attrs:{"d":"M9.07 14.9a5.237 5.237 0 100-10.474 5.237 5.237 0 000 10.473zm3.703-1.535l1.665 1.67m-.856.855l1.708-1.709 3.138 3.137a1.21 1.21 0 01-1.712 1.711l-3.137-3.137.003-.002z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"fill":"currentColor","d":"M0 0h20v20H0z"}})])])])
          )
        }
      }
    